import AdminContainer from '../../Utility/AdminContainer';
import useSettings from '../../../Hooks/useSettings';
import GeneralSettings from './components/GeneralSettings';
import DataProtection from './components/DataProtection';
import InstanceSettings from './components/InstanceSettings';
import { SettingsTabName } from '../../../Types/Enums';
import ToggleSwitch from '../../Utility/ToggleSwitch';
import System from './components/System';
import AdvancedSettings from './components/AdvancedSettings';
import Select from '../../Utility/FormElements/Select';

function Settings() {
    const {
        SettingsActions,
        models,
        embeddingModels,
        settingsLoaded,
        currentTab,
        setCurrentTab,
        userSettings,
        i18n,
        windowWidth,
        getBreakpoint,
        Currentsettings,
        mdParser,
    } = useSettings();

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                {settingsLoaded && (
                    <>
                        <div className="mb-5 w-full">
                            {windowWidth > getBreakpoint('md') ? (
                                <ToggleSwitch
                                    options={[
                                        {
                                            label: i18n.translate({ id: 'general', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.general),
                                            active: currentTab === SettingsTabName.general,
                                        },
                                        {
                                            label: i18n.translate({ id: 'dataProtection', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.dataprotection),
                                            active: currentTab === SettingsTabName.dataprotection,
                                        },
                                        {
                                            label: i18n.translate({ id: 'instance', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.instanceSettings),
                                            active: currentTab === SettingsTabName.instanceSettings,
                                            renderCondition: userSettings.isAvency,
                                        },
                                        {
                                            label: i18n.translate({ id: 'advancedSettings', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.advancedSettings),
                                            active: currentTab === SettingsTabName.advancedSettings,
                                        },
                                        {
                                            label: i18n.translate({ id: 'system', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.system),
                                            active: currentTab === SettingsTabName.system,
                                        },
                                    ]}
                                />
                            ) : (
                                <Select
                                    value={currentTab}
                                    onChange={(tab) => {
                                        setCurrentTab(tab as SettingsTabName);
                                    }}
                                >
                                    <option value={SettingsTabName.general}>
                                        {i18n.translate({ id: 'general', sourceName: 'Settings' })}
                                    </option>
                                    <option value={SettingsTabName.dataprotection}>
                                        {i18n.translate({ id: 'dataProtection', sourceName: 'Settings' })}
                                    </option>
                                    <option value={SettingsTabName.instanceSettings}>
                                        {i18n.translate({ id: 'instance', sourceName: 'Settings' })}
                                    </option>
                                    <option value={SettingsTabName.advancedSettings}>
                                        {i18n.translate({ id: 'advancedSettings', sourceName: 'Settings' })}
                                    </option>
                                    <option value={SettingsTabName.system}>
                                        {i18n.translate({ id: 'system', sourceName: 'Settings' })}
                                    </option>
                                </Select>
                            )}
                        </div>
                        <div className="box">
                            {currentTab === 'general' && (
                                <GeneralSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    models={models}
                                    embeddingModels={embeddingModels}
                                    windowWidth={windowWidth}
                                    getBreakpoint={getBreakpoint}
                                    mdParser={mdParser}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'dataprotection' && (
                                <DataProtection
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'instanceSettings' && userSettings.isAvency && (
                                <InstanceSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'advancedSettings' && (
                                <AdvancedSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'system' && <System />}
                        </div>
                    </>
                )}
            </AdminContainer>
        </div>
    );
}

export default Settings;
